import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('hr', {
    staticClass: "site__divider",
    class: _vm.classes,
    style: _vm.styles
  });
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-076ff036_0", {
    source: ".site__divider{background:var(--p-divider-color);border:0;margin:30px auto;height:2px;width:90px}.site__divider--dashed,.site__divider--fade,.site__divider--glow,.site__divider--rainbow,.site__divider--wide,.site__divider--zigzag{width:100%}.site__divider--dashed{background:linear-gradient(to right,transparent,transparent 50%,var(--p-divider-color) 50%,var(--p-divider-color));background-size:20px 100%;height:2px}.site__divider--rainbow{background:linear-gradient(to right,#62efab 5%,#f2ea7d 15%,#f2ea7d 25%,#ff8797 35%,#ff8797 45%,#e1a4f4 55%,#e1a4f4 65%,#82fff4 75%,#82fff4 85%,#62efab 95%);height:3px}.site__divider--vertical{height:60px;width:8px;margin:15px auto}.site__divider--vertical--medium{margin-bottom:30px;margin-top:30px}.site__divider--vertical--large{margin-bottom:45px;margin-top:45px}.site__divider--fade{background:linear-gradient(to right,transparent,var(--p-divider-color),transparent)}.site__divider--glow{height:6px;filter:blur(2px);border-radius:5px;background:linear-gradient(to right,var(--p-divider-color),var(--c-divider-glow))}.site__divider--zigzag{background:0 center repeat-x;height:6px;width:100%}.site__divider--medium{margin-bottom:45px;margin-top:45px}.site__divider--large{margin-bottom:60px;margin-top:60px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var ProfileDivider = __vue_component__;
export { ProfileDivider as default };